export default __webpack_public_path__ + "static/media/Q.34d4c122.png";